import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import { AlertCircle, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ValidatorModalProps {
  isOpen: boolean;
  onRequestAccess: () => void;
}

export const ValidatorModal = ({ 
  isOpen, 
  onRequestAccess 
}: ValidatorModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      // Quando o modal é fechado (X clicado), executar a mesma ação do botão
      if (!open) {
        onRequestAccess();
      }
    }}>
      <DialogContent 
        className="sm:max-w-[500px]" 
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-3 bg-amber-100 dark:bg-amber-900/20 rounded-full">
              <AlertCircle className="h-7 w-7 text-amber-600 dark:text-amber-500" />
            </div>
            <DialogTitle className="text-2xl">
              {t('auth.waitlist.title', { defaultValue: 'Acesso Restrito ao Trial' })}
            </DialogTitle>
          </div>
          <DialogDescription className="pt-4 text-base leading-relaxed">
            {t('auth.waitlist.description', { 
              defaultValue: 'Seu usuário não está inscrito na nossa lista de acesso antecipado para o plano Trial.' 
            })}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <p className="text-sm font-medium">
              {t('auth.waitlist.whatHappensTitle', { defaultValue: 'O que acontece agora?' })}
            </p>
            <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
              <li>
                {t('auth.waitlist.step1', { 
                  defaultValue: 'Você será registrado na lista de espera' 
                })}
              </li>
              <li>
                {t('auth.waitlist.step2', { 
                  defaultValue: 'Receberá um email quando o acesso for liberado' 
                })}
              </li>
              <li>
                {t('auth.waitlist.step3', { 
                  defaultValue: 'Poderá acessar o Prodgy assim que for aprovado' 
                })}
              </li>
            </ul>
          </div>
        </div>

        <DialogFooter>
          <Button 
            onClick={onRequestAccess} 
            className="w-full gap-2"
            size="lg"
          >
            <LogOut className="h-4 w-4" />
            {t('auth.waitlist.requestButton', { defaultValue: 'Solicitar Permissão' })}
          </Button>
        </DialogFooter>

        <p className="text-xs text-center text-muted-foreground pt-2">
          {t('auth.waitlist.footer', { 
            defaultValue: 'Você será desconectado e notificado por email quando o acesso estiver disponível.' 
          })}
        </p>
      </DialogContent>
    </Dialog>
  );
};
